import axios, { AxiosResponse } from "axios";

export const getCompanyName = async (id: string): Promise<AxiosResponse<string>> => {
    return await axios.get(`/dispatcher/company/${id}/name`);
};
